import React from 'react';
import PropTypes from 'prop-types';
import { IconClock } from '@/components/icons';
import { cn } from '@/helpers/utils';
import { useLoungeById } from '@/hooks/loungesHooks/loungesHelperHooks';
import { useRouteParams } from '@/context/routeParamsContext';
import {
  useCommonContent,
  useOneCmsLocaleDateFormattingObj,
} from '@/hooks/oneCmsIntlHooks/oneCmsIntlHelperHooks';
import { useSelector } from 'react-redux';
import { getLocaleData } from '@/selectors/localeSelectors';
import * as loungeHelper from '@/helpers/loungeHelper';

const LoungeOpenStatusText = ({ className }) => {
  const {
    lounges: { open: openLabel, closed: closedLabel, closesAt, opensAt },
  } = useCommonContent();
  const { loungeId } = useRouteParams();
  const lounge = useLoungeById(loungeId);
  const { locale } = useSelector(getLocaleData);
  const format = useOneCmsLocaleDateFormattingObj();

  const {
    isOpen: isLoungeOpen,
    closingTime,
    openingTime,
  } = loungeHelper.getLoungeCurrentStatus(locale, lounge, format.timeFormat);
  const isLoungeTempClosed = loungeHelper.isLoungeTempClosed(lounge);

  const hasInvalidTimings = !openingTime || !closingTime;

  // As we receive invalid timings for TempClosed state, the following condition helps to display the Lounge Close status if Lounge is temporarily closed.
  if (hasInvalidTimings && !isLoungeTempClosed) {
    return null;
  }

  return (
    <div className={cn(className, 'flex-row')}>
      {isLoungeOpen ? (
        <>
          <IconClock
            className="tw-mr-3 tw-icon-status-success-important"
            size="md"
          />
          <span
            className={cn(
              className,
              'heading-sans-xsmall-bold sans-xsmall-bold flex tw-text-status-success-important'
            )}
          >
            {openLabel}
          </span>
          {closingTime ? (
            <span className="flex flex-align-items-center tw-font-normal">
              &nbsp;• {closesAt} {closingTime}
            </span>
          ) : null}
        </>
      ) : (
        <>
          <IconClock
            className="tw-mr-3 tw-icon-status-caution-important"
            size="md"
          />
          <span className="flex tw-text-status-caution-important">
            {closedLabel}
          </span>
          {openingTime ? (
            <span className="flex flex-align-items-center tw-font-normal">
              &nbsp;• {opensAt} {openingTime}
            </span>
          ) : null}
        </>
      )}
    </div>
  );
};

LoungeOpenStatusText.defaultProps = {
  className: '',
};

LoungeOpenStatusText.propTypes = {
  className: PropTypes.string,
};

export default LoungeOpenStatusText;
